// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"AccountSettingsRightSidebar_sidebar__2ihOG","navSection":"AccountSettingsRightSidebar_navSection__26nz1"};